import Cookies from "js-cookie";
import { useRef } from "react";
import { Nav } from "react-bootstrap";
import { AiOutlineApartment } from "react-icons/ai";
import {
  FaFolderOpen,
  FaMailBulk,
  FaMoneyBill,
  FaMoneyBillWaveAlt,
  FaTachometerAlt,
  FaUser,
} from "react-icons/fa";
import { MdAdminPanelSettings } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";

const Sidebar = () => {
  const scrollContainerRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ get role from cookies
  const isParent = Cookies.get("isParent") === "true";

  // ✅ dynamic nav links (Franchise only for parent)
  const navLinks = [
    {
      to: "/franchise-dashboard",
      label: "Dashboard",
      icon: <FaTachometerAlt size={30} />,
    },

    ...(isParent
      ? [
          {
            to: "/franchise-dashboard/franchises",
            label: "My Partners",
            icon: <AiOutlineApartment size={30} />,
          },
        ]
      : []),

    {
      to: "/franchise-dashboard/customers",
      label: "Customers",
      icon: <MdAdminPanelSettings size={30} />,
    },
    {
      to: "/franchise-dashboard/frymes",
      label: "Frymes",
      icon: <FaMoneyBill size={30} />,
    },
     {
      to: "/franchise-dashboard/frymes-management",
      label: "Frymes Management",
      icon: <FaMoneyBillWaveAlt size={30} />,
    },
    {
      to: "/franchise-dashboard/contact-messages",
      label: "Contact Messages",
      icon: <FaMailBulk size={30} />,
    },
    {
        to: "/franchise-dashboard/profile",
        label: "Profile",
        icon: <FaUser size={30} />, 
      },
      {
        to: "/franchise-dashboard/settings",
        label: "Settings",
        icon: <FaFolderOpen size={30} />, 
      }
    ,
  ];

  // ✅ active link checker
  const isLinkActive = (link) => {
    if (!link?.to) return false;
    return location.pathname === link.to.split("?")[0];
  };

  const handleLinkClick = (to) => {
    navigate(to);
  };

  // ✅ render sidebar links
  const renderNavLinks = () => (
    <Nav className="flex-column full-height align-items-center">
      {navLinks.map((link, index) => (
        <div
          key={index}
          style={{
            position: "relative",
            width: "100%",
            marginBottom: "20px",
          }}
        >
          <div
            onClick={() => handleLinkClick(link.to)}
            className={`nav-link d-flex flex-column align-items-center ${
              isLinkActive(link) ? "active" : ""
            }`}
            style={{
              fontSize: "1.1rem",
              color: isLinkActive(link) ? "#663399" : "#332e38",
              textAlign: "center",
              padding: "10px",
              transition: "color 0.3s",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                position: "relative",
                height: "50px",
                minWidth: "100px",
                justifyContent: "center",
              }}
            >
              {link.icon && (
                <span style={{ marginBottom: "10px" }}>{link.icon}</span>
              )}
              {link.label}
            </div>

            {/* active triangle */}
            <div
              style={{
                width: "0",
                height: "0",
                borderStyle: "solid",
                borderWidth: "0 0 30px 30px",
                borderColor: "transparent transparent #663399 transparent",
                position: "absolute",
                top: "70%",
                left: "100%",
                marginLeft: "10px",
                display: isLinkActive(link) ? "block" : "none",
              }}
            />
          </div>

          <hr
            style={{
              width: "100%",
              borderColor: "black",
              margin: "5px 0",
            }}
          />
        </div>
      ))}
    </Nav>
  );

  return (
    <div
      ref={scrollContainerRef}
      className="sidebar"
      style={{
        width: "220px",
        backgroundColor: "#f8f9fa",
        height: "100vh",
        paddingTop: "30px",
      }}
    >
      {renderNavLinks()}
    </div>
  );
};

export default Sidebar;
